// Function to update cart badge count
function updateCartBadge(count) {
  const cartBadge = document.querySelector('.header__cart-badge');
  const cartLink = document.querySelector('a[href="/cart"]');
  
  if (count > 0) {
    if (cartBadge) {
      cartBadge.textContent = count;
    } else {
      const newBadge = document.createElement('span');
      newBadge.className = 'header__cart-badge';
      newBadge.setAttribute('aria-live', 'polite');
      newBadge.textContent = count;
      
      if (cartLink) {
        cartLink.appendChild(newBadge);
      }
    }
  } else {
    if (cartBadge) {
      cartBadge.remove();
    }
  }
}

class CartDrawer {
  constructor() {
    this.drawer = document.getElementById('cart-drawer');
    if (!this.drawer) return;
    
    this.container = this.drawer.querySelector('.cart-drawer__container');
    this.overlay = this.drawer.querySelector('.cart-drawer__overlay');
    this.closeBtn = this.drawer.querySelector('.cart-drawer__close');
    this.isInitialized = false;
    this.isUpdating = false;
    this.pendingUpdate = null;
    this.updateTimeout = null;
    
    this.init();
  }
  
  init() {
    // Close handlers
    this.closeBtn.addEventListener('click', () => this.close());
    
    // Only allow overlay close when NOT updating
    this.overlay.addEventListener('click', (e) => {
      if (!this.isUpdating) {
        this.close();
      }
    });
    
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.drawer.classList.contains('is-active') && !this.isUpdating) {
        this.close();
      }
    });
    
    this.attachAddToCartEvents();
    this.attachQuantityEvents();
    this.attachRemoveEvents();
    this.attachDiscountToggle();
    
    if (!this.isInitialized) {
      requestAnimationFrame(() => this.processText());
      this.isInitialized = true;
    }
  }
  
  attachDiscountToggle() {
    const discountToggle = this.drawer.querySelector('#discount-toggle');
    const discountContent = this.drawer.querySelector('#discount-content');
    const discountForm = this.drawer.querySelector('#discount-form');
    
    if (discountToggle && discountContent) {
      discountToggle.addEventListener('click', (e) => {
        e.stopPropagation();
        
        const isExpanded = discountToggle.getAttribute('aria-expanded') === 'true';
        
        discountToggle.setAttribute('aria-expanded', !isExpanded);
        discountContent.setAttribute('aria-hidden', isExpanded);
        
        if (!isExpanded) {
          setTimeout(() => {
            const input = discountContent.querySelector('.discount-input');
            if (input) input.focus();
          }, 300);
        }
      });
    }
    
    if (discountForm) {
      discountForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        const discountCode = discountForm.querySelector('#discount-code-input').value.trim();
        
        if (!discountCode) {
          alert('Please enter a discount code');
          return;
        }
        
        window.location.href = `/checkout?discount=${encodeURIComponent(discountCode)}`;
      });
    }
  }
  
  processText() {
    if (typeof window.processCartTextNodes === 'function') {
      const priceElements = this.drawer.querySelectorAll('[data-price]');
      priceElements.forEach(el => {
        el.removeAttribute('data-text-processed');
      });
      
      window.processCartTextNodes(this.drawer);
    }
  }
  
  attachAddToCartEvents() {
    const forms = document.querySelectorAll('form[action="/cart/add"]');
    
    forms.forEach(form => {
      const newForm = form.cloneNode(true);
      form.parentNode.replaceChild(newForm, form);
      
      newForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        
        const formData = new FormData(newForm);
        const button = newForm.querySelector('button[type="submit"]');
        
        button.disabled = true;
        
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData
          });
          
          if (response.ok) {
            this.open();
            await this.refreshCart();
          }
        } catch (error) {
          console.error('Error adding to cart:', error);
          alert('Failed to add item to cart');
        } finally {
          button.disabled = false;
        }
      });
    });
  }
  
  attachQuantityEvents() {
    const increaseButtons = this.drawer.querySelectorAll('.quantity-increase');
    const decreaseButtons = this.drawer.querySelectorAll('.quantity-decrease');
    
    increaseButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        if (btn.disabled) return;
        
        const key = btn.dataset.key;
        const displayElement = btn.previousElementSibling;
        const currentQty = parseInt(displayElement.textContent);
        const newQty = currentQty + 1;
        
        displayElement.textContent = newQty;
        this.queueQuantityUpdate(key, newQty);
      });
    });
    
    decreaseButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        if (btn.disabled) return;
        
        const key = btn.dataset.key;
        const displayElement = btn.nextElementSibling;
        const currentQty = parseInt(displayElement.textContent);
        
        if (currentQty > 1) {
          const newQty = currentQty - 1;
          displayElement.textContent = newQty;
          this.queueQuantityUpdate(key, newQty);
        }
      });
    });
  }
  
  attachRemoveEvents() {
    const removeButtons = this.drawer.querySelectorAll('.cart-item__remove');
    
    removeButtons.forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        if (this.isUpdating) return;
        
        const key = btn.dataset.key;
        const cartItem = btn.closest('.cart-item');
        
        cartItem.classList.add('removing');
        
        await this.updateQuantity(key, 0);
      });
    });
  }
  
  queueQuantityUpdate(key, quantity) {
    this.pendingUpdate = { key, quantity };
    
    if (this.updateTimeout) {
      clearTimeout(this.updateTimeout);
    }
    
    this.container.classList.add('updating-quantity');
    
    this.updateTimeout = setTimeout(() => {
      if (this.pendingUpdate) {
        this.updateQuantity(this.pendingUpdate.key, this.pendingUpdate.quantity);
        this.pendingUpdate = null;
      }
    }, 300);
  }
  
  async updateQuantity(key, quantity) {
    if (this.isUpdating) return;
    
    this.isUpdating = true;
    this.container.classList.add('updating');
    this.overlay.style.pointerEvents = 'none';
    
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: key,
          quantity: quantity
        })
      });
      
      if (response.ok) {
        const cartData = await response.json();
        updateCartBadge(cartData.item_count);
        await this.refreshCartSilent();
      }
    } catch (error) {
      console.error('Error updating cart:', error);
      await this.refreshCartSilent();
    } finally {
      this.isUpdating = false;
      this.container.classList.remove('updating');
      this.container.classList.remove('updating-quantity');
      this.overlay.style.pointerEvents = '';
    }
  }
  
  async refreshCartSilent() {
    try {
      const response = await fetch('/?section_id=cart-drawer');
      const html = await response.text();
      
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newContent = doc.querySelector('#cart-drawer');
      
      if (newContent) {
        const scrollPos = this.drawer.querySelector('.cart-drawer__items')?.scrollTop || 0;
        const wasActive = this.drawer.classList.contains('is-active');
        
        this.drawer.innerHTML = newContent.innerHTML;
        
        this.container = this.drawer.querySelector('.cart-drawer__container');
        this.overlay = this.drawer.querySelector('.cart-drawer__overlay');
        this.closeBtn = this.drawer.querySelector('.cart-drawer__close');
        
        this.closeBtn.addEventListener('click', () => this.close());
        this.overlay.addEventListener('click', (e) => {
          if (!this.isUpdating) {
            this.close();
          }
        });
        this.attachQuantityEvents();
        this.attachRemoveEvents();
        this.attachDiscountToggle();
        
        if (wasActive) {
          this.drawer.classList.add('is-active');
        }
        
        const itemsContainer = this.drawer.querySelector('.cart-drawer__items');
        if (itemsContainer) {
          itemsContainer.scrollTop = scrollPos;
        }
        
        const drawerCount = this.drawer.querySelector('.cart-drawer__count');
        if (drawerCount) {
          const count = parseInt(drawerCount.textContent);
          updateCartBadge(count);
        }
        
        requestAnimationFrame(() => this.processText());
      }
    } catch (error) {
      console.error('Error refreshing cart:', error);
    }
  }
  
  async refreshCart() {
    await this.refreshCartSilent();
  }
  
  open() {
    this.drawer.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }
  
  close() {
    if (this.isUpdating) return;
    
    this.drawer.classList.remove('is-active');
    document.body.style.overflow = '';
  }
}

// Initialize immediately
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.cartDrawerInstance = new CartDrawer();
  });
} else {
  window.cartDrawerInstance = new CartDrawer();
}

